import { useAuth } from '@gen2/hooks';
import { useSidebarStore } from '@gen2/hooks/stores';
import { usePageTitle } from '@gen2/hooks/usePageTitle';
import React, { FC, useLayoutEffect } from 'react';
import { Outlet } from 'react-router';
import { SharedDrawer } from '../components/organizing-request-modal/shared-drawer';
import { useSharedDrawerStore } from '../components/organizing-request-modal/store';
import { FooterNav } from './footer-nav/footerNav';
import { Header } from './header/header';
import { StyledContent, StyledLayout } from './layout.styled';
import { SidebarHeader } from './sidebar/header/header';
import { Sidebar } from './sidebar/sidebar';
export const Layout: FC = () => {
  const { user } = useAuth();
  const { subMenuWidth, subMenuOpen } = useSidebarStore();
  const { isOpen } = useSharedDrawerStore();
  const baseGutter = 90; // px

  const leftPadding = subMenuOpen ? subMenuWidth : baseGutter;

  useLayoutEffect(() => {
    if (!user) return;

    try {
      const { organisations } = user;

      pendo.initialize({
        visitor: {
          id: user?.email ?? '', // Email of the user
          uuid: user?.id ?? '', // UUID of the user
          full_name: `${user?.first_name} ${user?.last_name}`, // full name of the user
          countryCode: organisations[0].country_iso2_code ?? '', // country code of the user
        },
        account: {
          id: organisations[0].accounts[0].id ?? '', // id of the account
          // currentPlanName: 'FileInvite Free',
          companyName: organisations[0].name, // name of the organization
          environment: window.location.origin, // name of the environment
        },
      });
    } catch (e: unknown) {
      console.error('Pendo Error:', e);
    }
  }, [user]);

  // Use the page title hook to set the title based on the header
  usePageTitle();

  return (
    <StyledLayout>
      <Header />
      <StyledContent>
        <SidebarHeader />
        <Sidebar />
        <main
          style={{
            paddingLeft: leftPadding,
            transition: 'padding 0.3s ease',
          }}
        >
          <Outlet />
        </main>
        <FooterNav />
      </StyledContent>
      {isOpen && <SharedDrawer />}
    </StyledLayout>
  );
};
